/* eslint-disable @typescript-eslint/ban-ts-comment */
import classes from "./HomepageCollectionSkeleton.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const DefaultCompactInventoryCard = ({ showDistancePills = false }: any) => (
  <div className={classes.container} data-testid="propety-card">
    <div className={classes.defaultImage} data-testid="propety-image" />
    <div className={classes.content} data-testid="propety-name">
      <div className={classes.defaultTextBig} data-testid="propety-address" />
      {showDistancePills && (
        <div className={classes.defaultTextSmall} data-testid="propety-amount" />
      )}
    </div>
  </div>
);

export default wrapperHOC(DefaultCompactInventoryCard, {
  componentName: "DefaultCompactInventoryCard-HomepageCollectionSkeleton-Home",
  showForChina: true,
});
